import { cn } from "@/lib/utils";

/**
 * Marca do iLumeConecta: um coracao formado por duas metades que se
 * encaixam — terapeuta e familia — como na referencia visual.
 *
 * SVG inline em vez de arquivo: herda `currentColor`, entao funciona igual
 * no fundo claro do app dos pais e na sidebar escura do painel, sem manter
 * duas versoes do arquivo.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="iLumeConecta"
      className={cn("size-10 text-primary-600", className)}
    >
      <path
        d="M24 41.5C24 41.5 6 30.8 6 18.8C6 12.8 10.6 8.5 16.2 8.5C19.5 8.5 22.4 10.1 24 12.6C25.6 10.1 28.5 8.5 31.8 8.5C37.4 8.5 42 12.8 42 18.8C42 30.8 24 41.5 24 41.5Z"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinejoin="round"
      />
      {/* As duas figuras dentro do coracao: o vinculo que o produto cria. */}
      <circle cx="18.5" cy="20" r="3.1" fill="currentColor" />
      <circle cx="29.5" cy="20" r="3.1" fill="currentColor" opacity="0.55" />
      <path
        d="M13.4 29.2C13.4 26.4 15.7 24.6 18.5 24.6C21.3 24.6 23.6 26.4 23.6 29.2"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M24.4 29.2C24.4 26.4 26.7 24.6 29.5 24.6C32.3 24.6 34.6 26.4 34.6 29.2"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        opacity="0.55"
      />
    </svg>
  );
}

export function Logo({
  className,
  showTagline = false,
  size = "default",
}: {
  className?: string;
  showTagline?: boolean;
  size?: "sm" | "default" | "lg";
}) {
  const markSize = { sm: "size-8", default: "size-10", lg: "size-14" }[size];
  const textSize = { sm: "text-lg", default: "text-2xl", lg: "text-3xl" }[size];

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <LogoMark className={markSize} />
      <div className="flex flex-col">
        <span className={cn("font-semibold tracking-tight text-primary-700", textSize)}>
          iLume<span className="font-normal">Conecta</span>
        </span>
        {showTagline && (
          <span className="text-xs text-muted-foreground">Entre sessões, seguimos juntos.</span>
        )}
      </div>
    </div>
  );
}
